import { IMG } from './images';

export const heroImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/e621f426-7d68-46ac-b7f3-f2311ff9e0c6.jpg';

/** Intent-based entry points under the hero: "what situation are you in?" */
export const entryPaths = [
  { id: 'plug', title: 'Stekkerbatterij', detail: 'Zelf aansluiten op het stopcontact', href: '/shop/plug-in', from: 649 },
  { id: 'home', title: 'Vaste thuisbatterij', detail: 'Aangesloten door een installateur', href: '/shop/home-batteries', from: 2149 },
  { id: 'station', title: 'Powerstation', detail: 'Draagbaar, voor onderweg of noodstroom', href: '/shop/power-stations', from: 199 },
  { id: 'solar', title: 'Zonnepanelen', detail: 'Losse panelen of complete balkonset', href: '/shop/solar-panels', from: 99 },
] as const;

export const trustLine = [
  { lead: 'Meer dan', highlight: '10.000 klanten', tail: 'slaan hun eigen stroom op' },
  { lead: 'Binnen', highlight: '1–2 werkdagen', tail: 'verzonden' },
  { lead: 'Gratis verzending', highlight: 'vanaf € 50', tail: 'in NL & BE' },
];

/** Category showcase tiles. `kind` decides the treatment; deals is the single accent tile. */
export const showcaseTiles = [
  { id: 'plug-in', eyebrow: 'Plug-in', title: 'Thuisbatterijen', href: '/shop/plug-in', image: IMG.plugin, kind: 'category' },
  { id: 'power-stations', eyebrow: 'Draagbare', title: 'Powerstations', href: '/shop/power-stations', image: IMG.station, kind: 'category' },
  { id: 'home-batteries', eyebrow: 'Vaste', title: 'Thuisbatterij­systemen', href: '/shop/home-batteries', image: IMG.homeDark, kind: 'category' },
  { id: 'bundles', eyebrow: 'Zonnepaneel + powerstation', title: 'Voordeelbundels', href: '/deals', image: IMG.stationLife, kind: 'bundle' },
  { id: 'solar-panels', eyebrow: 'Full black & TOPCon', title: 'Zonnepanelen', href: '/shop/solar-panels', image: IMG.solar, kind: 'category' },
  { id: 'inverters', eyebrow: 'Hybride & off-grid', title: 'Omvormers', href: '/shop/inverters', image: IMG.inverter, kind: 'category' },
  { id: 'accessories', eyebrow: 'Meters & kabels', title: 'Accessoires', href: '/shop/accessories', image: IMG.accessory, kind: 'category' },
  { id: 'deals', eyebrow: 'Tot 25% korting', title: 'Ampra Deals', href: '/deals', image: '', kind: 'deals' },
] as const;

export const comparison = {
  columns: [
    { id: 'plug', title: 'Stekkerbatterij', tagline: 'Klein beginnen, zelf installeren', href: '/shop/plug-in', from: 649, cta: 'Bekijk stekkerbatterijen' },
    { id: 'home', title: 'Vaste thuisbatterij', tagline: 'Maximaal besparen, hele huis', href: '/shop/home-batteries', from: 2149, cta: 'Bekijk thuisbatterijen' },
  ],
  rows: [
    { label: 'Installatie', plug: 'Zelf, stekker in het stopcontact', home: 'Gecertificeerde installateur' },
    { label: 'Capaciteit', plug: '1,9 – 8 kWh', home: '5 – 16 kWh' },
    { label: 'Vermogen', plug: '800 – 2.400 W', home: '3,7 – 8 kW' },
    { label: 'Noodstroom', plug: 'Per stopcontact', home: 'Hele huis, binnen 10 ms' },
    { label: 'Ideaal voor', plug: 'Balkon, huurwoning, 2–6 panelen', home: '8+ panelen, warmtepomp of EV' },
    { label: 'Terugverdientijd', plug: '± 5–7 jaar', home: '± 6–8 jaar' },
  ],
};
